module.exports = __webpack_public_path__ + "static/media/icon_rin180e035b1d3d5418ca1afcd1352011e1.webp";